import { render } from "./BaseSelect.vue?vue&type=template&id=5a12d641"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script